<template>
  <div :class="['usb-transport']">
    
    <!-- SIDE CORRIDOR VIDEO -->
    <!-- <div id="tower-video" class="usb-section">
      <div id="tower-video-inner">
        <video playsinline muted preload autoplay loop>
          <source src="/figures/transport/towercityalley.mp4" type="video/mp4" />
        </video>
      </div>
    </div> -->

    <div class="spacer-5 mobile-show"></div>
    <div class="spacer-5 mobile-show"></div>

    <!-- THREE UP -->
    <div id="three-up-section" class="usb-section">
      <div class="three-up-background">
        <img class="desktop" src="/figures/transport/assembly-transport-desktop.png" />
        <img class="mobile" src="/figures/transport/assembly-transport-mobile.jpg" />
      </div>
      <div class="three-up-inner">
        <h1>USB Club’s Performance Key</h1>
        <div class="three-container">
          <div class="feature">
            <h3><span class="icon freight-icon-container"><img src="/figures/icons/freight-icon-beige.svg" class="diamond-icon"/></span><div class="feature-title-padded">1TB</div></h3>
            <h2>More storage than most laptops, in the palm of your hand.</h2>
          </div>
          <div class="feature">
            <h3><span class="icon ssd-icon-container"><img src="/figures/icons/ssd-beige.svg" class="ssd-icon"/></span><div class="feature-title-padded">SSD</div></h3>
            <h2>Solid State Drives enable lightning fast transfers.</h2>
          </div>
          <div class="feature">
            <h3><span class="icon key-icon-container"><img src="/figures/icons/performance-key-beige.svg" class="key-icon"/></span><div class="feature-title-padded">USB Club Access</div></h3>
            <h2>Each USB comes with an invite to the network.</h2>
          </div>
        </div>
      </div>
      <div class="bottom-gradient gradient"></div>
      <div class="top-gradient gradient"></div>
    </div>


    <!-- CAROUSEL -->
    <div class="usb-section" id="carousel">
      <CarouselTransport></CarouselTransport>
    </div>

    <div class="usb-section" id="carousel-mobile">
      <CarouselTransportMobile></CarouselTransportMobile>
    </div>


    <!-- PORTABLE SSD -->
    <div class="usb-section" id="portable-ssd">
      <div class="video-container">
        <video playsinline muted preload autoplay loop class="desktop">
          <source src="/figures/transport/Aerodynamic-Glowbe-LoopTestOrigSmoke.mp4#t=0.001" type="video/mp4" />
        </video>
        <video playsinline muted preload autoplay loop class="mobile">
          <source src="/figures/transport/Aerodynamic-Glowbe_Portrait_NoTransportPlate_Looper.mp4#t=0.001" type="video/mp4" />
        </video>
        <div class="bottom-gradient gradient"></div>
        <div class="top-gradient gradient"></div>
      </div>
      <div class="text-container">
        <h3>PORTABLE SSD</h3>
        <h1>Drive Faster</h1>
        <h2>USBs used to be slow. Transport's <span class="mobile">portable </span>SSD gives you 7x faster transfer times. That’s 5GBs in 15sec.</h2>
      </div>

    </div>
    <div class="usb-section" id="carry-what-matters">
      <div class="text-container">
        <h3>1 TB = 1,000,000,000,000 Bytes</h3>
        <h1>Carry What Matters</h1>
        <h2 class="desktop">200,000 songs <i>or&nbsp;</i> 333,000 photos <i>or&nbsp;</i> 500 hours of video
          <i>or&nbsp;</i> 1,000,000 PDFs
        </h2>
        <h2 class="mobile">200,000 songs <br /><i>or&nbsp;</i><br /> 333,000 photos<br /> <i>or&nbsp;</i><br /> 500
          hours of video<br /> <i>or&nbsp;</i> <br />1,000,000 PDFs</h2>

      </div>
      <div class="top-gradient gradient"></div>
      <div class="bottom-gradient gradient"></div>
    </div>


    <!-- PLUG AND PLAY -->
    <div class="usb-section desktop" id="plug-and-play">
      <div class="text-container">
        <h3>UNLOCK NEW DOORS</h3>
        <h1>Plug & Play</h1>
        <h2>Connect your USB to share and discover files and people like you.</h2>
        <h4>Via the <span><img src="/figures/icons/apple.svg" /></span> Mac Desktop App</h4>
      </div>
    </div>

    <!-- <div class="usb-section" id="section-2">
      <div class="scroll-video-outer">
        <div class="text-container mobile">
          <h3>UNLOCK NEW DOORS</h3>
          <h1>Plug & Play</h1>
          <h2>Connect your USB to share and discover files and people like you.</h2>
          <h4>Via the <span><img src="/figures/icons/apple.svg" /></span> Mac Desktop App</h4>
        </div>
        <div class="scroll-video-inner">
          <video playsinline muted preload class="usb-scene" ref="plugInScene">
            <source src="/figures/transport/PlugIn6b.webm" type="video/webm" />
          </video>
          <div class="top-gradient gradient"></div>
          <div class="bottom-gradient gradient"></div>
        </div>

      </div>
    </div> --> 
    
    <div class="usb-section" id="section-2">
    <div class="scroll-video-outer">
      <div class="text-container mobile">
        <h3>UNLOCK NEW DOORS</h3>
        <h1>Plug & Play</h1>
        <h2>Connect your USB to share and discover files and people like you.</h2>
        <h4>
          Via the <span><img src="/figures/icons/apple.svg" /></span> Mac Desktop App
        </h4>
      </div>
      <!-- <div class="scroll-video-inner">
        <video playsinline muted preload="auto" class="usb-scene" ref="plugInScene">
          <source src="/figures/transport/PlugIn6b.webm" type="video/webm" />
        </video>
        <div class="top-gradient gradient"></div>
        <div class="bottom-gradient gradient"></div>
      </div> -->
      <div class="scroll-video-inner">
        <!-- Conditionally render video or canvas -->
        <video
          v-if="!isMobile"
          playsinline
          muted
          preload="auto"
          class="usb-scene"
          ref="plugInScene"
        >
          <source src="/figures/transport/PlugIn6b.webm" type="video/webm" />
        </video>
        <canvas
          v-else
          class="usb-scene"
          ref="imageSequenceCanvas"
        ></canvas>
        <div class="top-gradient gradient"></div>
        <div class="bottom-gradient gradient"></div>
      </div>
    </div>
  </div>

    <!-- END CTA -->
    <div class="usb-section" id="end-cta">
      <div class="text-container">
        <img src="/figures/transport-logotype.png" class="transport-logo" />
        <h2>Limited supply available.</h2>
        <div class="cta-container">
          <span class="detail-text detail-left">1 TB Drive</span>
          <a href="https://buy.usb.club/products/transport" class="button cta-button"><span>Buy</span> $180 →</a>
          <span class="detail-text detail-right">Club Key</span>
        </div>
      </div>
      <div class="colophon">
        <img src="/figures/transport/colophon-1.svg">
        <img src="/figures/transport/colophon-2.svg">
      </div>
      <div class="bottom-button">
        <a href="/classic" class="button cta-button"><span>or View Classic</span> →</a>
      </div>
      <div class="top-gradient gradient"></div>
    </div>
  </div>
</template>

<script>

import CarouselTransport from "./CarouselTransport.vue"
import CarouselTransportMobile from "./CarouselTransportMobile.vue"

import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// If you're using GSAP 3.11 or later, you might need to import ScrollTrigger separately:
import ScrollTrigger from "gsap/ScrollTrigger";

export default {
  name: "USB_Transport",
  components: {
    CarouselTransport,
    CarouselTransportMobile
  },
  data() {
    return {
      controller: null,
      videoScene: null,
    };
  },
  computed: {
    isMobile() {
      return /Mobi|Android/i.test(navigator.userAgent);
    },
    isSafari() {
      const userAgent = navigator.userAgent;
      const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      return isSafari;
    }
  },
  created() {
  },
  mounted() {
    console.log('isSafari', this.isSafari)
    gsap.registerPlugin(ScrollTrigger);
    
    // this.setupScroll();
    // this.setupScrollTrigger();
    // this.setupManualRefresh();

    // || this.isSafari 
    if (this.isMobile) {
      this.setupImageSequence();
    } else {
      this.setupScrollTrigger();
      // this.setupScroll();
    }
  },
  methods: {
      setupImageSequenceSafari() {
          const frameCount = 144; // Adjust according to your image sequence
          const urls = new Array(frameCount).fill().map((_, i) => {
            return `/figures/transport/plug-in-frames-desktop/frame_${(i + 1).toString().padStart(4, '0')}.jpg`;
            // return `/figures/transport/rotation_frames_compressed/rotation_${(i + 1 + 200).toString().padStart(4, '0')}.webp`;
            // return `/path/to/your/images/frame${(i + 1).toString().padStart(4, '0')}.jpg`;
          });

          const canvas = this.$refs.imageSequenceCanvas;
          const img = new Image();
          img.src = urls[0];
          img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
          };

          this.imageSequence({
            urls,
            canvas,
            scrollTrigger: {
              trigger: "#section-2",
              start: "top center",
              end: () =>
                `+=${document.querySelector("#section-2").offsetHeight * 1.15}`,
              scrub: true,
              // markers: true, // Uncomment for debugging
            },
            clear: true,
          });
        },
      setupImageSequence() {
        const frameCount = 203; // Adjust according to your image sequence
        const urls = new Array(frameCount).fill().map((_, i) => {
          return `/figures/transport/plug-in-frames/out-${(i + 1 + 0).toString().padStart(4, '0')}.jpg`;
          // return `/figures/transport/rotation_frames_compressed/rotation_${(i + 1 + 200).toString().padStart(4, '0')}.webp`;
          // return `/path/to/your/images/frame${(i + 1).toString().padStart(4, '0')}.jpg`;
        });

        const canvas = this.$refs.imageSequenceCanvas;
        const img = new Image();
        img.src = urls[0];
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
        };

        this.imageSequence({
          urls,
          canvas,
          scrollTrigger: {
            trigger: "#section-2",
            start: "top center",
            end: () =>
              `+=${document.querySelector("#section-2").offsetHeight * 1.15}`,
            scrub: true,
            // markers: true, // Uncomment for debugging
          },
          clear: true,
        });
      },
      imageSequence(config) {
        let playhead = { frame: 0 },
          canvas = this.$refs.imageSequenceCanvas,
          ctx = canvas.getContext("2d"),
          curFrame = -1,
          onUpdate = config.onUpdate,
          images,
          updateImage = () => {
            let frame = Math.round(playhead.frame);
            if (frame !== curFrame) {
              config.clear && ctx.clearRect(0, 0, canvas.width, canvas.height);
              ctx.drawImage(images[frame], 0, 0);
              curFrame = frame;
              onUpdate && onUpdate.call(this, frame, images[frame]);
            }
          };

        images = config.urls.map((url, i) => {
          let img = new Image();
          img.src = url;
          img.crossOrigin = "anonymous";
          if (i === 0) img.onload = updateImage;
          return img;
        });

        return gsap.to(playhead, {
          frame: images.length - 1,
          ease: "none",
          onUpdate: updateImage,
          duration: images.length / (config.fps || 30),
          paused: !!config.paused,
          scrollTrigger: config.scrollTrigger,
        });
      },
    setupManualRefresh() {
      // Reference to 'this' to access component data and methods inside the function
      const self = this;

      // Add event listeners for scroll and touchmove
      document.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('touchmove', onScroll, { passive: true });

      // Callback function
      function onScroll() {
        // Randomize background color
        document.body.style.backgroundColor = getRandomColor();

        // Example logic for loading more content when reaching the bottom
        // if (window.scrollY + window.innerHeight >= document.body.scrollHeight) {
        //   self.track_page++;
        //   self.load_contents(self.track_page);
        // }
      }

      // Helper function to generate a random color
      function getRandomColor() {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      }
    },
    // setupManualRefresh(){
    //   $(document.body).on('touchmove', onScroll); // for mobile
    //   $(window).on('scroll', onScroll); 

    //   // callback
    //   function onScroll(){ 
    //     document.body.style.background = 'blue';
        
    //       if( $(window).scrollTop() + window.innerHeight >= document.body.scrollHeight ) { 
    //           track_page++; 
    //           load_contents(track_page); 
    //       }
    //   }
    // },
    setupScrollTrigger(){
      const videoEl = this.$refs.plugInScene;

      // Ensure the video metadata is loaded to get the duration
      videoEl.addEventListener("loadedmetadata", () => {
        const duration = videoEl.duration;

        // const animation = gsap
        //   .timeline({
        //     scrollTrigger: {
        //       trigger: '.hearedListing',
        //       scrub: true,
        //       start: 'top 90%',
        //       end: 'bottom top',
        //       markers: false
        //     }
        //   })
        //   .fromTo(
        //     '.hearedListing li',
        //     {
        //       x: 300,
        //       autoAlpha: 0
        //     },
        //     {
        //       x: 0,
        //       autoAlpha: 1,
        //       duration: 4,
        //       stagger: 2,
        //       ease: Power1.out
        //     }
        //   )
        gsap.to(videoEl, {
          currentTime: duration,
          ease: "none",
          scrollTrigger: {
            trigger: "#section-2",
            start: "top center",
            end: () => `+=${document.querySelector("#section-2").offsetHeight * 1.15}`,
            scrub: true,
            // scrub: 0.1, // Adjust the value as needed
            // markers: true, // Uncomment to see the scroll markers
            // useRAF: false,
            // invalidateOnRefresh: true,
            // fastScrollEnd: true,
          },
        });
      });
    },
    setupScroll() {
      // init controller
      this.controller = new ScrollMagic.Controller();

      // Function to get the height of the trigger element
      function getVideoHeight() {
        return document.querySelector("#section-2").offsetHeight * 1.15;
      }

      // create a scene
      this.videoScene = new ScrollMagic.Scene({
        triggerElement: "#section-2",
        triggerHook: 0.5, // where in page height it starts
        duration: getVideoHeight,
      })
        // .addIndicators()
        // .setPin('#section-2') // pins the element for the the scene's duration
        .addTo(this.controller) // assign the scene to the controller
        .on("progress", e => {
          // console.log('[scroll] progress:', e.progress)
          this.updatePlugInVideo(e.progress);
        })

    },
    updatePlugInVideo(progress) {
      let videoEl = this.$refs.plugInScene;
      if (!videoEl.duration) {
        console.log('video not loaded yet');
      }

      let newCurrentTime = progress * videoEl.duration;
      newCurrentTime = parseFloat(newCurrentTime).toPrecision(3)
      // newCurrentTime = parseFloat(newCurrentTime.toFixed(20));
      videoEl.currentTime = newCurrentTime;
      // set video current time based on progress percentage  
    }
  },
  head() {
    return {
      title: "Transport",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "Transport",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "The drive you've been looking for.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:image",
          content: "https://usb.club/figures/og/transportOG.png",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "description",
          content: "The drive you've been looking for.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "image",
          content: "https://usb.club/figures/og/transportOG.png",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "The drive you've been looking for.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "Transport",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:image",
          content: "https://usb.club/figures/og/transportOG.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.mobile {
  display: none;
}

.icon {
  width: 2.5rem;
  display: inline-flex;
}

.ssd-icon {
  transform: scale(1);
  position: relative;
  top: 4px;
  height: 20px;
}
.key-icon {
  transform: scale(1.2);
  position: relative;
  top: 2px;
  height: 20px;
  margin-right: 2px;
}

.key-icon-container + .feature-title-padded {
  margin-left: 10px;
}

.ssd-icon-container + .feature-title-padded {
  margin-left: 4px;
}

.freight-icon-container + .feature-title-padded {
  margin-left: 7px;
}

.diamond-icon {
  position: relative;
  top: 4px;
  height: 20px;
  transform: scale(1.1);
}

.usb-transport {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;
  z-index: 100;
}

h1 {
  font-size: 52px;
}

h3 {
  font-family: 'ISO', monospace;
  font-size: 20px;
  letter-spacing: normal;
  font-weight: 600;
  color: #F9F9F9;
}

h2 {
  font-family: 'Untitled Serif', serif;
  font-size: 26px;
  letter-spacing: -1px;
  font-weight: 400;
  max-width: 48rem;
}

h4 {
  font-family: 'Untitled Serif', serif;
  color: #a9a9a9;
  font-size: 16px;
  letter-spacing: -0.5px;
  font-weight: 400;
}

.usb-section {
  padding: 16rem 8rem 16rem 8rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  position: relative;
}

.usb-scene {
  will-change: transform;
}

.usb-scene {
  width: 100%;
  height: auto;
}

#section-2 {
  height: 300vh;
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 0;
  background-color: black;

  .scroll-video-outer {
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    flex-direction: column;

  }

  .scroll-video-inner {
    position: relative;
  }

  .top-gradient {
    top: 0rem;
    height: 6rem;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .bottom-gradient {
    bottom: 0rem;
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  }
}

#tower-video {
  padding: 8rem;
  box-sizing: border-box;
  max-height: 100vh;


}

#tower-video-inner {
  border-radius: 9999px;
  overflow: hidden;
  height: auto;
  max-height: calc(100vh - 16rem);
  max-width: 100%;
  aspect-ratio: 2/1;

  video {
    object-position: center;
    object-fit: cover;
    width: 100%;
  }

}

#three-up-section {
  padding: 0;
  height: 170vh;

  .three-up-inner {
    width: 100%;
    max-width: 100%;
    padding: 12rem 8rem 6rem 12rem;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
  }

  .three-up-background {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden; /* Ensures the image gets cropped */
  }

  .three-up-background img {
      width: 100%;
      height: 100%;
      object-fit: cover; /* Ensures the image covers the container */
      object-position: top; /* Anchors the image to the bottom */
  }

  h1 {
    color: #181818;
    margin-bottom: 6rem;
    font-weight: 800;
  }

  .three-container {
    display: flex;
    gap: 4rem;
    justify-content: center;

    .feature {
      display: block;
    }

    h2 {
      /* color: #bebebe; */
      color: #181818;
    }

    h3 {
      color: #181818;
    }
  }

  .top-gradient {
    top: -4rem;
    height: 8rem;
    background: linear-gradient(180deg, rgba(28, 28, 28, 0) 0%, rgba(200, 199, 187, 1) 50%, rgba(200, 199, 187, 0) 100%);
  }

  .bottom-gradient {
    bottom: 0rem;
    background: linear-gradient(0deg, rgba(28, 28, 28, 1) 0%, rgba(0, 0, 0, 0) 100%);
  }
}

/* @media screen and (max-width: 940px) {
  #three-up-section {
    height: 130vh;
  }
} */

/* @media screen and (max-width: 1135px) {
  #three-up-section {
    height: 142vh;
  }
} */

#carousel {
  padding: 8rem 4rem 2rem 4rem;
  position: relative;
  min-height: 104vh;
  box-sizing: border-box;
}

#carousel-mobile {
  display: none;
}


#portable-ssd {
  padding: 0;
  position: relative;
  min-height: 100vh;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .text-container {
    position: absolute;
    left: 8rem;
    bottom: 8rem;
  }

  .video-container {
    position: relative;
  }

  .top-gradient {
    top: 0;
    background: linear-gradient(180deg, rgba(28, 28, 28, 1) 0%, rgba(28, 28, 28, 0) 100%);
    height: 15rem;
  }

  .bottom-gradient {
    display: none;
  }

  h2 {
    max-width: 49rem;
  }
}

#carry-what-matters {
  background-image: url('/figures/transport/hand.webp');
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  padding: calc(13rem - 2.5vw) 2.5rem 16rem 2.5rem;

  .text-container {
    text-align: center;

    h2.desktop {
      max-width: 100%;
    }
  }

  .top-gradient {
    top: -6rem;
    height: 12rem;
    background: linear-gradient(180deg, rgba(88, 88, 90, 0) 0%, rgba(75, 79, 64, 1) 50%, rgba(75, 79, 64, 0) 100%);
  }

  .bottom-gradient {
    bottom: 0rem;
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(28, 28, 28, 0) 100%);
    height: 20rem;
  }
}

#plug-and-play {
  position: relative;
  background: black;
  padding-bottom: 4rem;
  padding-top: 10rem;

  .text-container {
    text-align: center;
  }

  .bottom-gradient {
    bottom: 0rem;
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(28, 28, 28, 0) 100%);
  }

  h2 {
    max-width: 40rem;
  }
}

.gradient {
  width: 100%;
  height: 6rem;
  position: absolute;
  background: rgb(28, 28, 28);
}


#end-cta {
  flex-direction: column;
  gap: 8rem;

  .text-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      margin-bottom: 2rem;
    }
  }

  .cta-container {
    text-align: center;
  }

  .colophon {
    display: flex;
    justify-content: space-evenly;

    img {
      width: 25vw;
      max-width: 250px;
    }
  }

  .top-gradient {
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(28, 28, 28, 0) 100%);

  }



}

@media screen and (max-width: 700px) {
  .mobile {
    display: unset;
  }

  .desktop {
    display: none;
  }

  .usb-section {
    padding: 4rem 2.5rem 8rem 2.5rem;
  }

  #tower-video {
    padding: 8rem 2rem 4rem 2rem;
  }

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 22px;
  }

  h3 {
    font-size: 16px;
  }

  #three-up-section {
    height: 134vh;

    h1 {
      margin-bottom: 4rem;
    }

    .three-container {
      flex-direction: column;
    }

    .three-up-background img {
      object-fit: cover; /* Ensures it scales properly while covering */
      width: 150%; /* Scales up the image */
      height: auto; /* Keeps aspect ratio */
      object-position: bottom center; /* Maintains bottom and center alignment */
    }

    .three-up-inner {
      padding: 8rem 3rem 0rem 3rem
    }

    .top-gradient {
      background: linear-gradient(180deg, rgba(28, 28, 28, 0) 0%, rgba(67, 71, 56, 1) 50%, rgba(67, 71, 56, 0) 100%);
    }
  }

  #carousel {
    display: none
  }

  #carousel-mobile {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
  }

  #portable-ssd {
    min-height: unset;
    flex-direction: column-reverse;
    padding-bottom: 0;

    .text-container {
      padding: 4rem 2.5rem 2rem 2.5rem;
      /* position: unset; */
      left: unset;
      /* top: unset; */
      top: 2rem;
    }

    .top-gradient {
      height: 2rem;
    }

    .bottom-gradient {
      display: none;
      bottom: 0;
      background: linear-gradient(0deg, rgba(28, 28, 28, 1) 0%, rgba(28, 28, 28, 0) 100%);
      height: 2rem;
    }
  }

  #carry-what-matters {
    min-height: 180vw;
    background-position: top;
    background-size: 140%;
    padding: 6rem 2rem 8rem 2rem;

    .top-gradient {
      background: linear-gradient(180deg, rgba(88, 88, 90, 0) 0%, rgb(40 47 44) 50%, rgba(40, 47, 44, 0) 100%);
      height: 4rem;
      top: -2rem;
    }
    .bottom-gradient {
      background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(28, 28, 28, 0) 100%);
      height: 2rem;
      bottom: 0;
    }
  }

  #section-2 {
    .scroll-video-outer {
      top: 6rem;
      justify-content: flex-start;

      .text-container {
        padding: 8rem 2.5rem 4rem 2.5rem;
        text-align: center;
      }
    }
  }

  #end-cta {
    .colophon {
      justify-content: space-between;
    img {
      width: 37.5vw;
      max-width: 250px;
    }
  }
  }



}
</style>
